import { render, staticRenderFns } from "./adetail.vue?vue&type=template&id=52eb9bf0"
import script from "./adetail.vue?vue&type=script&lang=js"
export * from "./adetail.vue?vue&type=script&lang=js"
import style0 from "./adetail.vue?vue&type=style&index=0&id=52eb9bf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports